import moment from 'moment';

const Message = ({ item, is_me }) => {
  const classMessageIsMe = is_me && {
    wrapper: 'justify-end',
    message: 'bg-primary-701 order-2',
    arrow: 'bg-primary-701 -bottom-1 -right-1',
  };
  const classMessageNotMe = !is_me && {
    wrapper: 'justify-start',
    message: 'bg-gray-651 order-0',
    arrow: 'bg-gray-651 -bottom-1 -left-1',
  };

  return (
    <>
      <div className={`flex mb-2.5 ${classMessageIsMe.wrapper || ''} ${classMessageNotMe.wrapper || ''}`}>
        <div className="flex gap-1 max-w-[75%] items-end px-2">
          <div
            className={`message-wrapper-arrow p-4 rounded-lg relative  ${classMessageIsMe.message || ''} ${classMessageNotMe.message || ''}`}
            style={{
              '--arrow-color': is_me ? 'var(--primary-color-701)' : 'var(--gray-color-651)',
              '--arrow-right': is_me ? '-10px' : 'auto',
              '--arrow-left': is_me ? 'auto' : '-10px',
              '--arrow-rotate': is_me ? '-50deg' : '50deg',
            }}
          >
            <div
              className="font-medium relative z-2 min-h-6 break-all"
              dangerouslySetInnerHTML={{ __html: item.content.replace(/ /g, '&nbsp;').replace(/\n/g, '<br />') }}
            ></div>
          </div>
          <div className="text-xs text-secondary-354">{moment(item.created_at).format('HH:mm')}</div>
        </div>
      </div>
    </>
  );
};

export default Message;
